import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  split: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',

    '& > div': {
      flexBasis: '50%',
      padding: '1.5rem 0',
      marginBottom: '2rem'
    }
  },

  button: {
    padding: '0 1rem',
    fontSize: theme.size.sm,

    '& .icon': {
      marginRight: '20px',
      fontSize: theme.size.lg
    }
  },

  arrow: {
    margin: '2.5rem 0 2.5rem 0',
    display: 'flex',
    alignItems: 'center',
    color: theme.palette.primary.main,
    cursor: 'pointer',
    fontSize: theme.size.sm,

    [theme.breakpoints.up(950)]: {
      margin: '1rem 0 1rem 0'
    }
  },

  mobile: {
    justifyContent: 'flex-start'
  }
}))

export default useStyles
